(function () {
    // The selector asset can be referenced by both the global theme layout and
    // cart markup. Only install one set of listeners/observers if the browser
    // encounters the asset more than once.
    if (window.__houlisDeliverySelectorLoaded) return;
    window.__houlisDeliverySelectorLoaded = true;

    function bootDeliverySelector() {
    var VALID_POSTCODES = ['3162', '3163', '3165', '3183', '3184', '3185', '3186', '3187', '3188', '3189', '3191', '3193', '3181', '3145'];
    var DELIVERY_FEE = 15.00;
    var MIN_LEAD_HOURS = 30;

    var DELIVERY_TIME_SLOTS = [
        '11:00 AM – 1:00 PM',
        '1:00 PM – 3:00 PM',
        '3:00 PM – 5:00 PM'
    ];

    var PICKUP_TIME_SLOTS = [
        '10:00 AM – 11:00 AM',
        '11:00 AM – 12:00 PM',
        '12:00 PM – 1:00 PM',
        '1:00 PM – 2:00 PM',
        '2:00 PM – 3:00 PM',
        '3:00 PM – 4:00 PM',
        '4:00 PM – 4:30 PM'
    ];

    var PICKUP_TIME_SLOTS_SATURDAY = [
        '10:00 AM – 11:00 AM',
        '11:00 AM – 12:00 PM',
        '12:00 PM – 1:00 PM',
        '1:00 PM – 2:00 PM'
    ];

    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // ── State map (survives DOM replacement) ──
    var stateMap = new WeakMap();
    var containerSequence = 0;
    var isUpdating = false;

    // Checkout stays disabled while any /cart/update.js POST is scheduled or
    // in flight — a fast checkout click must never beat the attribute write.
    var pendingCartUpdates = 0;
    var cartUpdateFailed = false;

    // ── Persistent state via sessionStorage ──
    var STATE_KEY = 'ds_state';
    function saveState(mode, postcode, dateStr, time) {
        try {
            sessionStorage.setItem(STATE_KEY, JSON.stringify({
                mode: mode,
                postcode: postcode || '',
                date: dateStr || '',
                time: time || ''
            }));
        } catch (e) { /* ignore */ }
    }
    function loadState() {
        try {
            var raw = sessionStorage.getItem(STATE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (e) { return null; }
    }

    // ── Pure helpers ──
    // All availability math runs on Melbourne wall-clock time, not the
    // customer's browser clock (an overseas customer could otherwise select
    // slots inside the lead window). Returns a Date whose local fields
    // represent Melbourne local time.
    function melbourneNow() {
        try {
            var parts = new Intl.DateTimeFormat('en-US', {
                timeZone: 'Australia/Melbourne',
                year: 'numeric', month: 'numeric', day: 'numeric',
                hour: 'numeric', minute: 'numeric', second: 'numeric',
                hour12: false
            }).formatToParts(new Date());
            var map = {};
            for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
            var hour = parseInt(map.hour, 10) === 24 ? 0 : parseInt(map.hour, 10);
            return new Date(
                parseInt(map.year, 10), parseInt(map.month, 10) - 1, parseInt(map.day, 10),
                hour, parseInt(map.minute, 10), parseInt(map.second, 10)
            );
        } catch (e) {
            return new Date(); // very old browsers: fall back to local clock
        }
    }

    function getLeadCutoff() {
        var d = melbourneNow();
        d.setHours(d.getHours() + MIN_LEAD_HOURS);
        return d;
    }

    function getMinDate(allowSaturday) {
        var d = getLeadCutoff();
        while (d.getDay() === 0 || (!allowSaturday && d.getDay() === 6)) {
            d.setDate(d.getDate() + 1);
        }
        d.setHours(0, 0, 0, 0);
        return d;
    }

    function parseSlotStartTime(dateObj, slotStr) {
        var startPart = slotStr.split('\u2013')[0].trim();
        var match = startPart.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (!match) return null;
        var hours = parseInt(match[1], 10);
        var minutes = parseInt(match[2], 10);
        var ampm = match[3].toUpperCase();
        if (ampm === 'PM' && hours !== 12) hours += 12;
        if (ampm === 'AM' && hours === 12) hours = 0;
        var dt = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), hours, minutes);
        return dt;
    }

    function isAvailableDay(date, allowSaturday) {
        var day = date.getDay();
        if (day === 0) return false; // Sunday always blocked
        if (day === 6 && !allowSaturday) return false; // Saturday blocked for delivery
        return true;
    }

    function formatDate(date) {
        return date.getDate() + ' ' + MONTHS[date.getMonth()] + ' ' + date.getFullYear();
    }

    function validatePostcode(postcode) {
        return VALID_POSTCODES.indexOf(postcode.trim().replace(/\s/g, '')) > -1;
    }

    // Parse a formatDate() string ("27 February 2026") back into a Date
    function parseStoredDate(str) {
        var m = /^(\d{1,2}) (\w+) (\d{4})$/.exec(str || '');
        if (!m) return null;
        var month = MONTHS.indexOf(m[2]);
        if (month < 0) return null;
        return new Date(parseInt(m[3], 10), month, parseInt(m[1], 10));
    }

    // ── Dynamic scroll parent finder ──
    function getScrollParent(node) {
        if (node == null || node === document.body) { return null; }
        if (node.scrollHeight > node.clientHeight) {
            var style = window.getComputedStyle(node);
            if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
                return node;
            }
        }
        return getScrollParent(node.parentNode);
    }

    // ── Reusable smooth scroll with double-scroll strategy ──
    var scrollTimer = null;
    function smoothScrollTo(targetElement, offset) {
        if (!targetElement) return;
        if (typeof offset === 'undefined') offset = 20;

        var scrollParent = getScrollParent(targetElement);
        if (!scrollParent) return;

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
            var parentRect = scrollParent.getBoundingClientRect();
            var targetRect = targetElement.getBoundingClientRect();
            var relativeOffset = targetRect.top - parentRect.top;
            var targetScrollTop = scrollParent.scrollTop + relativeOffset - offset;

            // Step 1: Scroll inside the widget
            scrollParent.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth'
            });

            // Step 2: Ensure widget is visible in outer drawer
            scrollParent.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 150);
    }

    // ── Container-scoped helpers ──
    function isDeliveryMode(container) {
        var radio = container.querySelector('input[value="delivery"]');
        return radio && radio.checked;
    }

    function getState(container) {
        return stateMap.get(container) || null;
    }

    // ── JIT initialisation (self-healing if observer is slow/missing) ──
    function ensureState(container) {
        var state = getState(container);
        if (!state) {
            console.log('[delivery-selector] JIT init — state missing, initialising now');
            initContainer(container);
            state = getState(container);
        }
        return state;
    }

    // ── Checkout Gating ──
    function updateCheckoutState(container) {
        var state = getState(container);
        if (!state) return;
        var checkoutBtns = document.querySelectorAll('[name="checkout"], #checkout');
        var postcodeInput = container.querySelector('[data-ds="postcode-input"]');
        var isComplete = false;

        if (isDeliveryMode(container)) {
            isComplete = postcodeInput && validatePostcode(postcodeInput.value.trim()) && state.selectedDate !== null && state.selectedTime !== null;
        } else {
            isComplete = state.selectedDate !== null && state.selectedTime !== null;
        }

        // Selections are only real once persisted to cart attributes
        var saving = pendingCartUpdates > 0 || cartUpdateFailed;
        var enable = isComplete && !saving;

        for (var i = 0; i < checkoutBtns.length; i++) {
            checkoutBtns[i].disabled = !enable;
            checkoutBtns[i].style.opacity = enable ? '1' : '0.5';
            checkoutBtns[i].style.cursor = enable ? 'pointer' : 'not-allowed';
            checkoutBtns[i].title = enable ? '' :
                (isComplete ? 'Saving your delivery details…' : 'Please select delivery/pickup date and time');
        }
    }

    // ── Calendar ──
    function renderCalendar(container) {
        var state = getState(container);
        if (!state) return;
        var calGrid = container.querySelector('[data-ds="cal-grid"]');
        var calMonthYear = container.querySelector('[data-ds="cal-month-year"]');
        if (!calGrid || !calMonthYear) return;

        isUpdating = true;
        calGrid.innerHTML = '';
        calMonthYear.textContent = MONTHS[state.calendarMonth] + ' ' + state.calendarYear;

        var firstDay = new Date(state.calendarYear, state.calendarMonth, 1).getDay();
        var daysInMonth = new Date(state.calendarYear, state.calendarMonth + 1, 0).getDate();
        var allowSaturday = !isDeliveryMode(container);
        var minDate = getMinDate(allowSaturday);
        var maxDate = melbourneNow();
        maxDate.setDate(maxDate.getDate() + 60);

        for (var i = 0; i < firstDay; i++) {
            calGrid.appendChild(document.createElement('div'));
        }

        for (var day = 1; day <= daysInMonth; day++) {
            var cell = document.createElement('div');
            var cellDate = new Date(state.calendarYear, state.calendarMonth, day);
            cell.textContent = day;

            var isAvailable = isAvailableDay(cellDate, allowSaturday) && cellDate >= minDate && cellDate <= maxDate;

            if (isAvailable) {
                cell.style.color = '#333';
                cell.setAttribute('data-ds', 'cal-day');
                cell.setAttribute('data-date', cellDate.toISOString());
            } else {
                cell.style.color = '#ccc';
            }

            if (state.selectedDate && cellDate.toDateString() === state.selectedDate.toDateString()) {
                cell.dataset.selected = 'true';
            }

            calGrid.appendChild(cell);
        }
        isUpdating = false;
    }

    function initCalendar(container) {
        var state = getState(container);
        if (!state) return;
        var min = getMinDate();
        state.calendarMonth = min.getMonth();
        state.calendarYear = min.getFullYear();
        renderCalendar(container);
    }

    // ── Time Slots ──
    function renderTimeSlots(container) {
        var state = getState(container);
        if (!state) return;
        var timeSlotsEl = container.querySelector('[data-ds="time-slots"]');
        if (!timeSlotsEl) return;

        isUpdating = true;
        timeSlotsEl.innerHTML = '';
        var slots;
        if (isDeliveryMode(container)) {
            slots = DELIVERY_TIME_SLOTS;
        } else {
            // For pickup: use Saturday-restricted slots if date is Saturday, else full slots
            if (state.selectedDate && state.selectedDate.getDay() === 6) {
                slots = PICKUP_TIME_SLOTS_SATURDAY;
            } else {
                slots = PICKUP_TIME_SLOTS;
            }
        }

        // Filter out slots that fall within the lead time window on the earliest date
        var cutoff = getLeadCutoff();

        for (var i = 0; i < slots.length; i++) {
            // On the minimum date, hide slots whose start time is before the lead cutoff
            if (state.selectedDate) {
                var slotStart = parseSlotStartTime(state.selectedDate, slots[i]);
                if (slotStart && slotStart < cutoff) continue;
            }

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = slots[i];
            btn.setAttribute('data-ds', 'time-btn');
            btn.setAttribute('data-slot', slots[i]);

            if (state.selectedTime === slots[i]) {
                btn.dataset.selected = 'true';
            }

            timeSlotsEl.appendChild(btn);
        }
        isUpdating = false;
    }

    // ── Cart Update (debounced; checkout gated until the write lands) ──
    function updateCart(container) {
        var state = getState(container);
        if (!state) return;
        var postcodeInput = container.querySelector('[data-ds="postcode-input"]');
        var instructionsInput = container.querySelector('[data-ds="instructions-input"]');

        if (!state.cartPending) {
            state.cartPending = true;
            pendingCartUpdates++;
        }
        updateCheckoutState(container);

        clearTimeout(state.cartTimer);
        state.cartTimer = setTimeout(function () {
            var method = isDeliveryMode(container) ? 'delivery' : 'pickup';
            var postcode = postcodeInput ? postcodeInput.value.trim() : '';
            var instructions = instructionsInput ? instructionsInput.value.trim() : '';

            // Every key is always written so a mode switch or re-pick can
            // never leave stale values on the order (webhook alerts on
            // missing attributes; it must never dispatch on stale ones).
            var attrs = {
                'Delivery Method': method === 'delivery' ? 'Local Delivery' : 'Pickup in store',
                'Delivery Postcode': method === 'delivery' ? postcode : '',
                'Delivery Fee': method === 'delivery' ? DELIVERY_FEE.toFixed(2) : '0.00',
                'Delivery Date': state.selectedDate ? formatDate(state.selectedDate) : '',
                'Delivery Time': state.selectedTime || '',
                'Dropoff Instructions': method === 'delivery' ? instructions : ''
            };

            saveState(method, postcode, state.selectedDate ? formatDate(state.selectedDate) : '', state.selectedTime || '');

            function settle(ok) {
                if (state.cartPending) {
                    state.cartPending = false;
                    pendingCartUpdates = Math.max(0, pendingCartUpdates - 1);
                }
                cartUpdateFailed = !ok;
                updateCheckoutState(container);
                if (!ok) {
                    // Keep checkout blocked and retry until the write lands
                    console.error('[delivery-selector] cart update failed — retrying in 2s');
                    setTimeout(function () { updateCart(container); }, 2000);
                }
            }

            isUpdating = true;
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attrs })
            })
                .then(function (r) {
                    if (!r.ok) throw new Error('HTTP ' + r.status);
                    return r.json();
                })
                .then(function (cart) {
                    console.log('Cart updated:', cart.attributes);
                    settle(true);
                    setTimeout(function () { isUpdating = false; }, 500);
                })
                .catch(function (err) {
                    console.error('Cart update failed:', err);
                    isUpdating = false;
                    settle(false);
                });
        }, 300);
    }

    // ── Visibility Toggle ──
    function updateVisibility(container) {
        var state = getState(container);
        if (!state) return;

        var postcodeSection = container.querySelector('[data-ds="postcode-section"]');
        var pickupSection = container.querySelector('[data-ds="pickup-section"]');
        var postcodeInput = container.querySelector('[data-ds="postcode-input"]');
        var postcodeSuccess = container.querySelector('[data-ds="postcode-success"]');
        var postcodeError = container.querySelector('[data-ds="postcode-error"]');
        var dateSection = container.querySelector('[data-ds="date-section"]');
        var dateDisplay = container.querySelector('[data-ds="date-display"]');
        var calendarContainer = container.querySelector('[data-ds="calendar-container"]');
        var timeSection = container.querySelector('[data-ds="time-section"]');
        var instructionsSection = container.querySelector('[data-ds="instructions-section"]');

        state.selectedDate = null;
        state.selectedTime = null;
        if (dateDisplay) {
            dateDisplay.textContent = 'Select Date';
            dateDisplay.dataset.placeholder = 'true';
        }
        if (calendarContainer) calendarContainer.style.display = 'none';

        if (isDeliveryMode(container)) {
            if (postcodeSection) postcodeSection.style.display = 'block';
            if (pickupSection) pickupSection.style.display = 'none';
            if (instructionsSection) instructionsSection.style.display = 'none';
            if (dateSection) dateSection.style.display = 'none';
            if (timeSection) timeSection.style.display = 'none';
            var pc = postcodeInput ? postcodeInput.value.trim() : '';
            if (pc && validatePostcode(pc)) {
                if (postcodeSuccess) postcodeSuccess.style.display = 'block';
                if (postcodeError) postcodeError.style.display = 'none';
                if (dateSection) dateSection.style.display = 'block';
                initCalendar(container);
            }
        } else {
            if (postcodeSection) postcodeSection.style.display = 'none';
            if (pickupSection) pickupSection.style.display = 'block';
            if (instructionsSection) instructionsSection.style.display = 'none';
            if (dateSection) dateSection.style.display = 'block';
            if (timeSection) timeSection.style.display = 'none';
            initCalendar(container);
            updateCart(container);
        }
        updateCheckoutState(container);
    }

    // ══════════════════════════════════════════════
    //  SETUP-ONLY initContainer (NO event listeners)
    // ══════════════════════════════════════════════
    function initContainer(container) {
        if (container.dataset.dsInit) return;
        container.dataset.dsInit = 'true';

        // Initialise state for this container
        stateMap.set(container, {
            selectedDate: null,
            selectedTime: null,
            calendarMonth: null,
            calendarYear: null,
            cartTimer: null,
            cartPending: false
        });

        var deliveryRadio = container.querySelector('input[value="delivery"]');
        var pickupRadio = container.querySelector('input[value="pickup"]');
        var postcodeInput = container.querySelector('[data-ds="postcode-input"]');

        if (!deliveryRadio || !pickupRadio) return;

        // The cart drawer and full cart page can coexist in the same document.
        // Give each widget its own radio group so initialising the hidden
        // widget cannot uncheck the visible widget's delivery method.
        var radioGroupName = 'delivery_type_' + (++containerSequence);
        deliveryRadio.name = radioGroupName;
        pickupRadio.name = radioGroupName;

        // Restore saved state from sessionStorage
        var saved = loadState();
        if (saved) {
            if (saved.mode === 'pickup') {
                pickupRadio.checked = true;
            } else {
                deliveryRadio.checked = true;
                if (saved.postcode && postcodeInput) postcodeInput.value = saved.postcode;
            }
        } else {
            // Multiple server-rendered widgets initially share one radio name,
            // so the browser may clear this container's checked property before
            // the groups are isolated above. Delivery is the safe explicit
            // default when there is no persisted customer choice.
            deliveryRadio.checked = true;
        }

        updateVisibility(container);
        restoreSelection(container, saved);
        updateCheckoutState(container);
    }

    // Re-apply the saved date/time after a cart re-render destroyed the DOM
    // (updateVisibility nulls them, which used to force a re-pick and could
    // leave stale attributes on the order).
    function restoreSelection(container, saved) {
        if (!saved || !saved.date) return;
        var state = getState(container);
        if (!state) return;

        if (isDeliveryMode(container)) {
            var postcodeInput = container.querySelector('[data-ds="postcode-input"]');
            var pc = postcodeInput ? postcodeInput.value.trim() : '';
            if (!validatePostcode(pc)) return;
        }

        var allowSaturday = !isDeliveryMode(container);
        var d = parseStoredDate(saved.date);
        if (!d || !isAvailableDay(d, allowSaturday) || d < getMinDate(allowSaturday)) return;

        state.selectedDate = d;
        var dateDisplay = container.querySelector('[data-ds="date-display"]');
        if (dateDisplay) {
            dateDisplay.textContent = formatDate(d);
            delete dateDisplay.dataset.placeholder;
        }

        renderTimeSlots(container);
        var timeSection = container.querySelector('[data-ds="time-section"]');
        if (timeSection) timeSection.style.display = 'block';

        if (saved.time) {
            // Only restore a slot that is still offered for this date
            var slotBtns = container.querySelectorAll('[data-ds="time-btn"]');
            for (var i = 0; i < slotBtns.length; i++) {
                if (slotBtns[i].getAttribute('data-slot') === saved.time) {
                    state.selectedTime = saved.time;
                    slotBtns[i].dataset.selected = 'true';
                    break;
                }
            }
        }

        if (state.selectedTime && isDeliveryMode(container)) {
            var instructionsSection = container.querySelector('[data-ds="instructions-section"]');
            if (instructionsSection) instructionsSection.style.display = 'block';
        }

        updateCart(container); // re-persist so attributes match the restored UI
    }

    // ══════════════════════════════════════════════
    //  DELEGATED EVENT LISTENERS (survive DOM replacement)
    // ══════════════════════════════════════════════

    // ── Input: postcode validation ──
    document.body.addEventListener('input', function (e) {
        var input = e.target;
        if (!input.matches('[data-ds="postcode-input"]')) return;
        var container = input.closest('.delivery-method-selector');
        if (!container) return;
        var state = ensureState(container);
        if (!state) return;

        var postcode = input.value.trim();
        if (!isDeliveryMode(container)) return;

        var postcodeError = container.querySelector('[data-ds="postcode-error"]');
        var postcodeSuccess = container.querySelector('[data-ds="postcode-success"]');
        var dateSection = container.querySelector('[data-ds="date-section"]');
        var timeSection = container.querySelector('[data-ds="time-section"]');
        var instructionsSection = container.querySelector('[data-ds="instructions-section"]');

        if (postcode.length >= 4 && validatePostcode(postcode)) {
            if (postcodeError) postcodeError.style.display = 'none';
            if (postcodeSuccess) postcodeSuccess.style.display = 'block';
            if (dateSection) dateSection.style.display = 'block';
            initCalendar(container);
            updateCart(container);
            // Case B: Auto-scroll to date picker after postcode success
            smoothScrollTo(dateSection);
        } else if (postcode.length >= 4) {
            if (postcodeError) postcodeError.style.display = 'block';
            if (postcodeSuccess) postcodeSuccess.style.display = 'none';
            if (dateSection) dateSection.style.display = 'none';
            if (timeSection) timeSection.style.display = 'none';
            if (instructionsSection) instructionsSection.style.display = 'none';
            state.selectedDate = null;
            state.selectedTime = null;
        } else {
            if (postcodeError) postcodeError.style.display = 'none';
            if (postcodeSuccess) postcodeSuccess.style.display = 'none';
            if (dateSection) dateSection.style.display = 'none';
            if (timeSection) timeSection.style.display = 'none';
            if (instructionsSection) instructionsSection.style.display = 'none';
        }
        updateCheckoutState(container);
    });

    // ── Keydown: suppress Enter on postcode ──
    document.body.addEventListener('keydown', function (e) {
        if (e.target.matches('[data-ds="postcode-input"]') && e.key === 'Enter') {
            e.preventDefault();
            e.target.blur();
        }
    });

    // ── Focusout: instructions blur → cart update ──
    document.body.addEventListener('focusout', function (e) {
        if (!e.target.matches('[data-ds="instructions-input"]')) return;
        var container = e.target.closest('.delivery-method-selector');
        if (!container) return;
        var state = ensureState(container);
        if (state && state.selectedDate && state.selectedTime) {
            updateCart(container);
        }
    });

    // ── Change: radio toggle ──
    document.body.addEventListener('change', function (e) {
        if (!e.target.matches(
            '.delivery-method-selector input[type="radio"][value="delivery"], ' +
            '.delivery-method-selector input[type="radio"][value="pickup"]'
        )) return;
        var container = e.target.closest('.delivery-method-selector');
        if (!container) return;
        var state = ensureState(container);
        if (!state) return;
        updateVisibility(container);

        // Case A: Auto-scroll to next step after radio toggle
        if (isDeliveryMode(container)) {
            var postcodeInput = container.querySelector('[data-ds="postcode-input"]');
            smoothScrollTo(postcodeInput);
        } else {
            var dateSection = container.querySelector('[data-ds="date-section"]');
            smoothScrollTo(dateSection);
        }
    });

    // ── Click: date display, calendar nav, day cells, time slots ──
    document.body.addEventListener('click', function (e) {
        var target = e.target;
        var container = target.closest('.delivery-method-selector');
        if (!container) return;
        var state = ensureState(container);
        if (!state) return;

        // Date display toggle
        if (target.closest('[data-ds="date-display"]')) {
            var calendarContainer = container.querySelector('[data-ds="calendar-container"]');
            if (calendarContainer) {
                var isVisible = calendarContainer.style.display !== 'none';
                calendarContainer.style.display = isVisible ? 'none' : 'block';
                if (!isVisible) {
                    initCalendar(container);
                    // Wait 100ms for mobile browsers to paint the calendar and update scrollHeight
                    setTimeout(function () {
                        var dateSection = container.querySelector('[data-ds="date-section"]');
                        smoothScrollTo(dateSection, 5);
                    }, 100);
                }
            }
            return;
        }

        // Calendar prev
        if (target.closest('[data-ds="cal-prev"]')) {
            state.calendarMonth--;
            if (state.calendarMonth < 0) { state.calendarMonth = 11; state.calendarYear--; }
            renderCalendar(container);
            return;
        }

        // Calendar next
        if (target.closest('[data-ds="cal-next"]')) {
            state.calendarMonth++;
            if (state.calendarMonth > 11) { state.calendarMonth = 0; state.calendarYear++; }
            renderCalendar(container);
            return;
        }

        // Calendar day cell
        if (target.matches('[data-ds="cal-day"]')) {
            var dateStr = target.getAttribute('data-date');
            if (!dateStr) return;
            var d = new Date(dateStr);
            state.selectedDate = d;
            state.selectedTime = null;

            var dateDisplay = container.querySelector('[data-ds="date-display"]');
            if (dateDisplay) {
                dateDisplay.textContent = formatDate(d);
                delete dateDisplay.dataset.placeholder;
            }

            var calCont = container.querySelector('[data-ds="calendar-container"]');
            if (calCont) calCont.style.display = 'none';

            renderTimeSlots(container);
            var timeSection = container.querySelector('[data-ds="time-section"]');
            if (timeSection) timeSection.style.display = 'block';

            // Case C: Auto-scroll to time slots after date selection
            smoothScrollTo(timeSection);

            // Highlight selected cell
            var calGrid = container.querySelector('[data-ds="cal-grid"]');
            if (calGrid) {
                var prev = calGrid.querySelectorAll('[data-selected]');
                for (var x = 0; x < prev.length; x++) {
                    delete prev[x].dataset.selected;
                }
            }
            target.dataset.selected = 'true';

            updateCart(container);
            updateCheckoutState(container);
            return;
        }

        // Time slot button
        if (target.matches('[data-ds="time-btn"]')) {
            var slot = target.getAttribute('data-slot');
            if (!slot) return;
            state.selectedTime = slot;

            var timeSlotsEl = container.querySelector('[data-ds="time-slots"]');
            if (timeSlotsEl) {
                var prevBtns = timeSlotsEl.querySelectorAll('[data-selected]');
                for (var x = 0; x < prevBtns.length; x++) {
                    delete prevBtns[x].dataset.selected;
                }
            }

            target.dataset.selected = 'true';

            if (isDeliveryMode(container)) {
                var instructionsSection = container.querySelector('[data-ds="instructions-section"]');
                if (instructionsSection) instructionsSection.style.display = 'block';
                // Case D: Auto-scroll to instructions after time selection
                smoothScrollTo(instructionsSection);
            } else {
                // Case D: Auto-scroll to checkout after time selection (pickup)
                var checkoutBtn = document.querySelector('[name="checkout"], #checkout');
                smoothScrollTo(checkoutBtn);
            }

            updateCart(container);
            updateCheckoutState(container);
            return;
        }
    });

    // ══════════════════════════════════════════════
    //  BOOTSTRAP + LIGHTWEIGHT OBSERVER
    // ══════════════════════════════════════════════
    function initAll() {
        var containers = document.querySelectorAll('.delivery-method-selector');
        for (var i = 0; i < containers.length; i++) {
            initContainer(containers[i]);
        }
    }

    initAll();

    // Observer on document.body — catches cart drawer even if injected late by theme JS
    var debounceTimer = null;
    var observer = new MutationObserver(function (mutations) {
        var shouldInit = false;
        for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].addedNodes.length > 0) {
                shouldInit = true;
                break;
            }
        }
        if (shouldInit && !isUpdating) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                var containers = document.querySelectorAll('.delivery-method-selector:not([data-ds-init])');
                for (var j = 0; j < containers.length; j++) {
                    initContainer(containers[j]);
                }
            }, 300);
        }
    });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    // A global defer script runs before DOMContentLoaded. This fallback also
    // supports a late script load on pages whose cart markup arrives via AJAX.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootDeliverySelector);
    } else {
        bootDeliverySelector();
    }
})();
